var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionsRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4927_19",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4927_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 34.5V25.5L16.35 22.5L14.85 29.1L4.5 27L5.1 24L12.3 25.5L14.7 13.35L12 14.4V19.5H9V12.45L14.925 9.9C15.8 9.525 16.4438 9.28125 16.8563 9.16875C17.2688 9.05625 17.65 9 18 9C18.525 9 19.0125 9.1375 19.4625 9.4125C19.9125 9.6875 20.275 10.05 20.55 10.5L22.05 12.9C22.7 13.95 23.5813 14.8125 24.6938 15.4875C25.8063 16.1625 27.075 16.5 28.5 16.5V19.5C26.85 19.5 25.3063 19.1563 23.8688 18.4688C22.4313 17.7812 21.225 16.875 20.25 15.75L19.35 20.25L22.5 23.25V34.5H19.5ZM20.25 8.25C19.425 8.25 18.7188 7.95625 18.1313 7.36875C17.5438 6.78125 17.25 6.075 17.25 5.25C17.25 4.425 17.5438 3.71875 18.1313 3.13125C18.7188 2.54375 19.425 2.25 20.25 2.25C21.075 2.25 21.7813 2.54375 22.3688 3.13125C22.9563 3.71875 23.25 4.425 23.25 5.25C23.25 6.075 22.9563 6.78125 22.3688 7.36875C21.7813 7.95625 21.075 8.25 20.25 8.25Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsRun);
export default __webpack_public_path__ + "static/media/directions_run.99c8b60c778fe89b4b0e4b9a9386db26.svg";
export { ForwardRef as ReactComponent };